module.exports = __webpack_public_path__ + "static/media/silvasa6.818836d9.webp";